import { Modal } from 'antd'
import CreateEventDrawerContent from './CreateEventDrawerContent'
import JobSearchFilters from './JobSearchFilters'
import { useScheduleFilters } from '../ScheduleFiltersContext'
import { SchedulingJob } from '../scheduleApi'

type Props = {
  open: boolean
  onClose: () => void
  onJobSelected: (job: SchedulingJob) => void
}

const JobPickerModal = ({ open, onClose, onJobSelected }: Props) => {
  const { createEventFilters: filters, setCreateEventFilters: setFilters } = useScheduleFilters()

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={720}
      title="Select a Job"
      destroyOnHidden
    >
      <div style={{ display: 'flex', flexDirection: 'column', maxHeight: '70vh', overflow: 'auto' }}>
        <div style={{ backgroundColor: '#f5f5f5', padding: '12px', borderRadius: '8px', marginBottom: '12px' }}>
          <JobSearchFilters filters={filters} setFilters={setFilters} />
        </div>

        <CreateEventDrawerContent filters={filters} onJobSelected={onJobSelected} />
      </div>
    </Modal>
  )
}

export default JobPickerModal
